import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router'
import { OperadorService } from '../services/operador.service'
import { environment } from '../../../environments/environment'
import { BureauService } from '../services/bureau.service'
import { Operador } from '../../pkw-data/core/operador.model'
import { Bureau } from '../../pkw-data/core/bureau.model'

@Injectable()
export class CanActivateExtratoRouteGuard implements CanActivate {
    constructor(
        private operadorService: OperadorService,
        private bureauService: BureauService
    ) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let operador: Operador
        this.operadorService.corrente.subscribe((op) => (operador = op))

        let bureau: Bureau
        this.bureauService.corrente.subscribe((b) => (bureau = b))

        let podeAcessar =
            bureau.userConnection.possuiCollect &&
            operador.hasPermissaoVisualizarCollect()

        if (!podeAcessar) {
            window.location.assign(environment.packupBaseUrl)
        }

        return podeAcessar
    }
}



// WEBPACK FOOTER //
// ./src/app/core/guards/can-activate-extrato-route.guard.ts